import { faShieldKeyhole } from '@fortawesome/pro-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Box, Button, Stack, Typography, useTheme } from '@mui/material'
import { useNavigate } from 'react-router-dom'

function NotAuthorized() {
	const navigate = useNavigate()
	const theme = useTheme()
	return (
		<>
			<Box
				sx={{
					position: 'absolute',
					backgroundColor: theme.palette.secondary.main,
					boxShadow: '0px 4px 6px 0px #00000040',
				}}
				width="100%"
				height="54px"
			/>
			<Stack height="100vh" p="1rem" spacing="1.5rem" justifyContent="center" alignItems="center">
				<FontAwesomeIcon
					style={{ height: '150px', width: '150px' }}
					color={theme.palette.primary.main}
					icon={faShieldKeyhole}
				/>
				<Typography sx={{ textAlign: 'center' }} variant="h6">
					Sorry... But it looks like you do not have permission to view this page.
				</Typography>
				<Typography width="50%" sx={{ textAlign: 'center' }} variant="body1">
					Looks like you have tried to access a page you do not have access to. If this is a
					mistake, please contact your admin.
				</Typography>
				<Button onClick={() => navigate('/')} variant="contained" color="secondary">
					Back to Home
				</Button>
			</Stack>
		</>
	)
}

export default NotAuthorized
